import { NgClass, NgIf } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';

@Component({
  selector: 'lh-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [NgClass, MatIconModule, NgIf],
})
export class FooterComponent implements OnInit {
  brandingKey!: string;
  showContentFlag = false;
  constructor(@Inject(ENVIRONMENT) protected readonly env: ClientEnvironment) {}

  ngOnInit(): void {
    this.brandingKey = this.env.brandingKey as string;
  }

  disableContent() {
    this.showContentFlag = !this.showContentFlag;
  }
}
